const REGIONS = {
    US: [
        {
            regionName: 'Alabama',
            regionCode: 'AL',
        },
        {
            regionName: 'Alaska',
            regionCode: 'AK',
        },
        {
            regionName: 'American Samoa',
            regionCode: 'AS',
        },
        {
            regionName: 'Arizona',
            regionCode: 'AZ',
        },
        {
            regionName: 'Arkansas',
            regionCode: 'AR',
        },
        {
            regionName: 'California',
            regionCode: 'CA',
        },
        {
            regionName: 'Colorado',
            regionCode: 'CO',
        },
        {
            regionName: 'Connecticut',
            regionCode: 'CT',
        },
        {
            regionName: 'Delaware',
            regionCode: 'DE',
        },
        {
            regionName: 'District Of Columbia',
            regionCode: 'DC',
        },
        {
            regionName: 'Federated States Of Micronesia',
            regionCode: 'FM',
        },
        {
            regionName: 'Florida',
            regionCode: 'FL',
        },
        {
            regionName: 'Georgia',
            regionCode: 'GA',
        },
        {
            regionName: 'Guam',
            regionCode: 'GU',
        },
        {
            regionName: 'Hawaii',
            regionCode: 'HI',
        },
        {
            regionName: 'Idaho',
            regionCode: 'ID',
        },
        {
            regionName: 'Illinois',
            regionCode: 'IL',
        },
        {
            regionName: 'Indiana',
            regionCode: 'IN',
        },
        {
            regionName: 'Iowa',
            regionCode: 'IA',
        },
        {
            regionName: 'Kansas',
            regionCode: 'KS',
        },
        {
            regionName: 'Kentucky',
            regionCode: 'KY',
        },
        {
            regionName: 'Louisiana',
            regionCode: 'LA',
        },
        {
            regionName: 'Maine',
            regionCode: 'ME',
        },
        {
            regionName: 'Marshall Islands',
            regionCode: 'MH',
        },
        {
            regionName: 'Maryland',
            regionCode: 'MD',
        },
        {
            regionName: 'Massachusetts',
            regionCode: 'MA',
        },
        {
            regionName: 'Michigan',
            regionCode: 'MI',
        },
        {
            regionName: 'Minnesota',
            regionCode: 'MN',
        },
        {
            regionName: 'Mississippi',
            regionCode: 'MS',
        },
        {
            regionName: 'Missouri',
            regionCode: 'MO',
        },
        {
            regionName: 'Montana',
            regionCode: 'MT',
        },
        {
            regionName: 'Nebraska',
            regionCode: 'NE',
        },
        {
            regionName: 'Nevada',
            regionCode: 'NV',
        },
        {
            regionName: 'New Hampshire',
            regionCode: 'NH',
        },
        {
            regionName: 'New Jersey',
            regionCode: 'NJ',
        },
        {
            regionName: 'New Mexico',
            regionCode: 'NM',
        },
        {
            regionName: 'New York',
            regionCode: 'NY',
        },
        {
            regionName: 'North Carolina',
            regionCode: 'NC',
        },
        {
            regionName: 'North Dakota',
            regionCode: 'ND',
        },
        {
            regionName: 'Northern Mariana Islands',
            regionCode: 'MP',
        },
        {
            regionName: 'Ohio',
            regionCode: 'OH',
        },
        {
            regionName: 'Oklahoma',
            regionCode: 'OK',
        },
        {
            regionName: 'Oregon',
            regionCode: 'OR',
        },
        {
            regionName: 'Palau',
            regionCode: 'PW',
        },
        {
            regionName: 'Pennsylvania',
            regionCode: 'PA',
        },
        {
            regionName: 'Puerto Rico',
            regionCode: 'PR',
        },
        {
            regionName: 'Rhode Island',
            regionCode: 'RI',
        },
        {
            regionName: 'South Carolina',
            regionCode: 'SC',
        },
        {
            regionName: 'South Dakota',
            regionCode: 'SD',
        },
        {
            regionName: 'Tennessee',
            regionCode: 'TN',
        },
        {
            regionName: 'Texas',
            regionCode: 'TX',
        },
        {
            regionName: 'Utah',
            regionCode: 'UT',
        },
        {
            regionName: 'Vermont',
            regionCode: 'VT',
        },
        {
            regionName: 'Virgin Islands',
            regionCode: 'VI',
        },
        {
            regionName: 'Virginia',
            regionCode: 'VA',
        },
        {
            regionName: 'Washington',
            regionCode: 'WA',
        },
        {
            regionName: 'West Virginia',
            regionCode: 'WV',
        },
        {
            regionName: 'Wisconsin',
            regionCode: 'WI',
        },
        {
            regionName: 'Wyoming',
            regionCode: 'WY',
        },
    ],
    CA: [
        {
            regionName: 'Alberta',
            regionCode: 'AB',
        },
        {
            regionName: 'British Columbia',
            regionCode: 'BC',
        },
        {
            regionName: 'Manitoba',
            regionCode: 'MB',
        },
        {
            regionName: 'New Brunswick',
            regionCode: 'NB',
        },
        {
            regionName: 'Newfoundland and Labrador',
            regionCode: 'NL',
        },
        {
            regionName: 'Nova Scotia',
            regionCode: 'NS',
        },
        {
            regionName: 'Nunavut',
            regionCode: 'NU',
        },
        {
            regionName: 'Northwest Territories',
            regionCode: 'NT',
        },
        {
            regionName: 'Ontario',
            regionCode: 'ON',
        },
        {
            regionName: 'Prince Edward Island',
            regionCode: 'PE',
        },
        {
            regionName: 'Quebec',
            regionCode: 'QC',
        },
        {
            regionName: 'Saskatchewan',
            regionCode: 'SK',
        },
        {
            regionName: 'Yukon',
            regionCode: 'YT',
        },
    ],
};

export default REGIONS;
